import {
	hamburgerButton,
	overlay,
	likeTriggers,
	expandTranscriptionInside,
	expandTranscriptionOutside,
	audioToggle,
	popups,
	searchRestrictions,
	sidebar,
	lessonSidebar,
	popupToggles,
	postTypesFacet,
	searchForm,
	mqMenu,
	menuParentItems,
	searchToggle,
	sidebarToggleButton,
	registerForm,
	wistiaEmbed,
	registerUserRoles,
	AcceptTermsButtons,
	AcceptTermsCheckboxes,
	earningsBar,
	surveyForm,
	countdownBar,
	exportUserCompletedLessonsButtons,
} from './lib/elements.js'
import {
	toggleMenu,
	applyCommentVoteStyling,
	toggleTranscription,
	toggleAudio,
	closeAllQuestionPopups,
	toggleSearchBox,
	toggleSearchStatus,
	makeSidebarSticky,
	closePopupOnOverlayClick,
	togglePopup,
	appendFacetCategories,
	joinCheckboxesOnSubmit,
	moveSearchButton,
	handleMenuClick,
	toggleSidebar,
	scrollLoopToTop,
	joinUserPermissions,
	markCompleteOnWistiaPlayed,
	calculateWistiaAspectatio,
	acceptTerms,
	enableReferralButton,
	moveEarningsBar,
	moveCountdownBar,
	indicateLoadingState,
	exportUserCompletedLessons,
} from './lib/handlers.js'
import { handleFirstTab, disableAnimationOnResize } from './lib/lib.js'

// Hamburger toggle
if (hamburgerButton) {
	hamburgerButton.addEventListener('click', toggleMenu)
	overlay.addEventListener('click', toggleMenu)
	document.addEventListener('keyup', toggleMenu)
}

if (menuParentItems.length > 0) {
	menuParentItems.forEach((item) => {
		item.addEventListener('click', handleMenuClick)
	})
}

// Remove :focus outline unless user is usjobLabeling the keyboard to navigate
window.addEventListener('keydown', handleFirstTab)

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize)

if (likeTriggers.length > 0) {
	likeTriggers.forEach((item) => {
		item.addEventListener('click', applyCommentVoteStyling)
	})
}

if (expandTranscriptionInside) {
	expandTranscriptionInside.addEventListener('click', toggleTranscription)
	expandTranscriptionOutside.addEventListener('click', toggleTranscription)
}
if (audioToggle) {
	audioToggle.addEventListener('click', toggleAudio)
}

if (popups.length > 0) {
	document.addEventListener('keyup', closeAllQuestionPopups)
	popups.forEach((item) => {
		item.addEventListener('click', closePopupOnOverlayClick)
	})
}

// Toggle search
document.addEventListener('click', toggleSearchBox)
document.addEventListener('keyup', toggleSearchBox)

if (searchRestrictions.length > 0) {
	searchRestrictions.forEach((item) => {
		item.addEventListener('click', toggleSearchStatus)
	})
}

// Apply sticky sidebar class
if (sidebar || lessonSidebar) {
	makeSidebarSticky()
	document.addEventListener('DOMContentLoaded', makeSidebarSticky)
	window.addEventListener('resize', makeSidebarSticky)
}

if (popupToggles.length > 0) {
	popupToggles.forEach((item) => {
		item.addEventListener('click', togglePopup)
	})
}

if (postTypesFacet) {
	appendFacetCategories()
}

if (searchForm) {
	searchForm.addEventListener('submit', joinCheckboxesOnSubmit)
}

if (searchToggle) {
	moveSearchButton(mqMenu)
	mqMenu.addListener(moveSearchButton)
}

if (earningsBar) {
	moveEarningsBar(mqMenu)
	mqMenu.addListener(moveEarningsBar)
}

if (countdownBar) {
	moveCountdownBar(mqMenu)
	mqMenu.addListener(moveCountdownBar)
}

if (sidebarToggleButton) {
	sidebarToggleButton.addEventListener('click', toggleSidebar)
}

// Scroll to firts result on facetWP refresh
jQuery(document).on('facetwp-loaded', scrollLoopToTop)

if (registerUserRoles.length > 0) {
	registerUserRoles.forEach((item) => {
		item.addEventListener('click', joinUserPermissions)
	})
}

if (wistiaEmbed) {
	// markCompleteOnWistiaPlayed()
	calculateWistiaAspectatio()
}

if (AcceptTermsButtons.length > 0) {
	AcceptTermsButtons.forEach((item) => {
		item.addEventListener('click', acceptTerms)
	})
}
if (AcceptTermsCheckboxes.length > 0) {
	AcceptTermsCheckboxes.forEach((item) => {
		item.addEventListener('input', enableReferralButton)
	})
}

if (surveyForm) {
	surveyForm.addEventListener('submit', indicateLoadingState)
}

if (exportUserCompletedLessonsButtons.length > 0) {
	exportUserCompletedLessonsButtons.forEach((item) => {
		item.addEventListener('click', exportUserCompletedLessons)
	})
}
